module.exports = __webpack_public_path__ + "img/barbecue.31004488.svg";